import { Helmet } from 'react-helmet';

export const updateMetaTags = (description, keywords) => {
  return (
    <Helmet>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
}